<app-signin-signup *ngIf="!phoneData && !userData" title="Start your fundraiser in seconds.<br/> It's free!" theme="saf"
  inputLabel="Mobile Number" [showBack]="true" [showFlag]="false" [popupView]="true" [numberOnly]="true"
  [hideAgree]="true" [hideStartFund]="true" [noRedirectAfterLogin]="true" [firebaseResponseOnlyForNew]="true"
  [showPopup]="true" [noRedirectAfterLogin]="true" [showOtpSeparate]="true" [showInputV2]="true"
  [dialogConfig]="{disableClose: true}"
  (onFirebaseRes)="onFirebaseRes($event)" />

<div *ngIf="isLoading" class="fullLoader body-loader"></div>

<div class="navbar" *ngIf="(phoneData || userData)">
  <a [href]="environment.APP.DOMAIN_URL" (click)="onLogoClick($event)">
    <img loading="lazy" [src]="logoUrlLight" width="70" height="35" alt="Ketto – Crowdfunding in India" />
  </a>
  <div class="lang-select-wrapper">
    <mat-form-field class="lang-form-field" appearance="none">
      <mat-select #langSelect [value]="selectedLang" (selectionChange)="setLang($event.value)"
        (opened)="onSelectOpened()" (closed)="onSelectClosed()" panelClass="lang-select-panel">
        <mat-option *ngFor="let lang of supportedLang" [value]="lang.key">
          {{ lang.label }}
        </mat-option>
      </mat-select>
      <!-- Custom icon trigger -->
      <div class="lang-button" [class.opened]="isSelectOpen" (click)="langSelect.open()">
        <mat-icon class="lang-icon">g_translate</mat-icon>
        <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
      </div>
    </mat-form-field>
  </div>
</div>


<div *ngIf="(phoneData || userData)" class="content">
  <div class="left-wrapper">
    <div *ngIf="(phoneData || userData)" [attr.lang]="selectedLang" class="back" (click)="goBack()">
      <em class="material-icons">arrow_back_ios</em> {{ getBackOrStartLabel() }}
    </div>
    <div class="stepper-wrapper">
      <app-stepper [formGroup]="formGroup" [formData]="formData" [causeName]="causeName"
        [isFinalStep]='formInstance?.isFinalStep' [selectedLang]="selectedLang" [supportedLang]="supportedLang"
        (setLanguage)="setLang($event)" (triggerGoBack)="goBack()" />
    </div>
  </div>
  <div *ngIf="formInfo" class="right-wrapper">
    <app-form #formInstance [formInfo]="formInfo" [otherInfo]="otherInfo" [draftData]="draftData"
      [buttonLabels]="buttonLabels" (onChange)="onFormChange($event)" (createCampaign)="reviewFundraiser()"
      (startFundraiser)="startFundraiser($event)" (sendLead)="sendLead($event)" />
  </div>
</div>